import React from "react";
import "./Supply.sass";
import logo from "./../../../assets/images/logo-pink.png";
import { Link } from "react-router-dom";

export default function Supply() {
  return (
    <div className="supply">
      <div className="supply-bg">
        <div className="supply-container">
          <h2 className="supply-title">SUPPLY</h2>
          <div className="supply-s1">
            <h3>1777</h3>
            <h6>First Edition Frens</h6>
            <h4>60%</h4>
          </div>
          <h2 className="supply-text mobile">
            Distributed over a set vesting schedule determined by the FrenDAO
          </h2>
          <div className="supply-s2">
            <div className="supply-s2-first">
              <h5>FREN DAO</h5>
              <h6>17 FrogGods & 100 DemiGods</h6>
              <h6>
                65% <br /> (39% of total)
              </h6>
            </div>
            <div className="supply-s2-second">
              <h5>1660 FREN</h5>
              <h6>35% (21% of total)</h6>
            </div>
          </div>
          <div className="supply-s3">
            <div className="supply-s3-first">
              <h5>CYBER FREN</h5>
              <h6>10%</h6>
            </div>
            <div className="supply-s3-second">
              <h5>LP</h5>
              <h6>20%</h6>
            </div>
            <div className="supply-s3-third">
              <h5>Reserve</h5>
              <h6>30%</h6>
            </div>
          </div>
        </div>
        <div className="supply-mobile mobile">
          <div className="hteam-logo">
            <div className="hteam-logo-img">
              <Link to="/">
                <img src="/images/logo.png" alt="logo" />
              </Link>
            </div>
          </div>
        </div>
        <div className="supply-footer not-mobile">
          <h2 className="">
            Distributed over a set vesting schedule determined by the FrenDAO
          </h2>
          <img src={logo} alt="logo" />
          <h3>
            IN PARTNER WITH WADISHADES <span>‘BAYO </span>
          </h3>
        </div>
      </div>
    </div>
  );
}
